import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@web-chat-core/ui-kit';
import { useSIPTelephony } from 'useCase';
import { PhoneCallButton, PhoneTextField, SIPCallContainer } from './view';

interface Props {
    onClose(): void;
}

export const SIPCallDial: React.FC<Props> = ({ onClose }) => {
    const { t } = useTranslation();
    const { addSIPParticipant } = useSIPTelephony();
    const [phone, setPhone] = useState<string>('');

    const handlePhoneChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        const newValue = e.currentTarget.value;

        // Разрешаем ввод только цифр
        if (/^[0-9]*$/.test(newValue)) {
            setPhone(newValue);
        }
    };

    const handleCallClick = () => {
        addSIPParticipant(phone);
        onClose();
    };

    const isCallDisabled = !phone.trim();

    return (
        <SIPCallContainer>
            <PhoneTextField
                type="text"
                value={phone}
                onChange={handlePhoneChange}
                placeholder={t('web_call_phone_number')}
                withStaticLabel
                removeOuterWith
                autoFocus
                autoComplete="off"
            />

            <PhoneCallButton onClick={handleCallClick} disabled={isCallDisabled}>
                <Icon icon="icPhoneOutput" colorVariant={isCallDisabled ? 'basic' : 'white'} />
            </PhoneCallButton>
        </SIPCallContainer>
    );
};
